import type { SxProps, Theme } from '@mui/material';

const WAVEFORM_HEIGHT = 88;

export const container: SxProps<Theme> = {
  width: '100%',
};

export const waveform = (theme: Theme): SxProps<Theme> => {
  const regionColor = theme.palette.primary.main;
  return {
    width: '100%',
    height: WAVEFORM_HEIGHT,
    // The Regions plugin renders inside wavesurfer's own shadow root, so
    // `::part` is the only way to reach its region/handle elements from
    // outside it. Their borders are set inline by the plugin, which needs
    // `!important` to override.
    '& > div': {
      '&::part(region)': {
        border: `1px solid ${regionColor}`,
        borderRadius: '8px !important',
      },
      '&::part(region-handle-left)': {
        borderLeftColor: `${regionColor} !important`,
        borderLeftWidth: '3px !important',
      },
      '&::part(region-handle-right)': {
        borderRightColor: `${regionColor} !important`,
        borderRightWidth: '3px !important',
      },
    },
  };
};

export const controlsRow: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 4,
  mt: 1,
};

export const playButton = (isDarkMode: boolean): SxProps<Theme> => ({
  width: 40,
  height: 40,
  backgroundColor: isDarkMode ? 'common.white' : 'primary.main',
  color: isDarkMode ? 'primary.main' : 'primary.contrastText',
  boxShadow:
    '0 3px 5px -1px rgba(16, 30, 36, 0.20), 0 6px 10px 0 rgba(16, 30, 36, 0.14), 0 1px 18px 0 rgba(16, 30, 36, 0.12)',
  '&:hover': {
    backgroundColor: isDarkMode ? 'rgba(255, 255, 255, 0.88)' : 'primary.dark',
  },
});

export const playIcon: SxProps<Theme> = {
  fontSize: 20,
};
